import { defineStore } from 'pinia'
// import { userController } from '#layers/cms/server/controllers/user.controller'

export const useUserStore = defineStore('user', {
    state: () => ({
        is_initialized: false,
        id: '' as string,
        email: '' as string,
        name: '' as string,
        avatar: '' as string,
        permissions: [] as UserPermission[],
        apiCredentials: '' as string | null,
        theme: '' as string,
        prefferedBucketStack: '' as string
    }),
    actions: {
        setUser(user: IUser) {
            try {
                this.id = user.id.toString()
                this.email = user.email.toString()
                this.name = user.name.toString()
                this.avatar = user.avatar.toString()
                if (user.apiCredentials) {
                    this.apiCredentials = user.apiCredentials.toString()
                } else {
                    this.apiCredentials = null
                }
                this.permissions = user.permissions ? user.permissions : []
                this.theme = user.theme.toString()
                this.is_initialized = true
                // this.prefferedBucketStack = user.prefferedBucketStack
            } catch (err) {
                console.error('user error', err)
            }
        },
        isLoggedIn() {
            return this.id !== ''
        },
        isAdmin() {
            return this.permissions.includes(UserPermission.admin)
        },
        saveTheme() {
            if (process.client) {
                window.localStorage.setItem('theme', this.theme ?? '')
            }
            // console.log(User)
            // User.updateOne({id: this.id}, {$set: {theme: 'lllll'}})
            // return this.theme = theme
        },

        // Fetch user from server
        async fetchUser() {
            try {
                const result = await $fetch<ApiResponse<IUser>>('/api/users/get-self', {
                    method: 'GET',
                    // $fetch doesn't carry the browser's session cookie during SSR.
                    headers: import.meta.server ? useRequestHeaders(['cookie']) : undefined,
                })
                if (!result.success) throw result.message
                this.setUser(result.data)
            } catch (error) {
                console.error(error)
                throw error
            }
        },
        // getTheme () {
        //   let prefferedTheme = ''
        //   // console.log(process.client && window.localStorage)
        //   if (process.client && window.localStorage && window.localStorage.getItem('theme')) prefferedTheme = window.localStorage.getItem('theme') ?? ''
        //   else {
        //     return prefferedTheme = 'light'
        //   }
        //   if (prefferedTheme === 'auto')
        // },
        setPrefferedBucketStack(prefferedBucketStack: string) {
            return this.prefferedBucketStack = prefferedBucketStack
        },
        setToken(token: string) {
            this.apiCredentials = token
        }
        // setThemeFromStorage () {
        //   this.theme = this.getTheme()
        // }
    },

})
